import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "besidaMob-back.icon",
  "use": "besidaMob-back.icon-usage",
  "viewBox": "0 0 10 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 15\" id=\"besidaMob-back.icon\"><path d=\"M9.5 12.757L4.124 7.295l5.337-4.977L7.704.5.5 7.219 7.667 14.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol